export {default as MobilePadding} from './MobilePadding';
